const Pricing = {
  label: 'Pricing',
  url: '/pricing',
  heapClass: 'au_topnav_pricing'
}

export default Pricing
